module.exports = "mutation DeleteLetter ($id: String!) {\n  status: deleteLetter(id: $id)\n}\n"


//////////////////
// WEBPACK FOOTER
// ./src/queries/DeleteLetter.graphql
// module id = 1882
// module chunks = 1611